import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const EPISODE_ENDPOINT = 'api/v1/admin/episodes';


function updateStep(episodeId: string, sceneId: string, stepId: string, data: any) {
    return api.update(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}`, data);
}

function deleteStep(episodeId: string, sceneId: string, stepId: string) {
    return api.delete(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}`);
}

function updateOption(episodeId: string, sceneId: string, stepId: string, optionId: string, data: any) {
    return api.update(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/options/${optionId}`, data);
}

function deleteOption(episodeId: string, sceneId: string, stepId: string, optionId: string) {
    return api.delete(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/options/${optionId}`);
}


////////////////////////////////////////

function getEpisodeById(episodeId: string) {
    return api.get(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}`, {});
}

function getScenesByEpisodeId(episodeId: string) {
    return api.get(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes`, {});
}

function updateScene(episodeId: string, sceneId: string, data: any) {
    return api.update(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}`, data);
}

function deleteScene(episodeId: string, sceneId: string, data: any) {
    return api.update(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/delete`, data);
}


function createStepFromStep(episodeId: string, sceneId: string, stepId: string) {
    return api.create(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/create_step`, {});
}

function createMultiStepFromStep(episodeId: string, sceneId: string, stepId: string, data: any) {
    return api.create(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/create_multi_step`, data);
}

function createBranchFromStep(episodeId: string, sceneId: string, stepId: string) {
    return api.create(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/create_branch`, {});
}

function createOptionFromStep(episodeId: string, sceneId: string, stepId: string) {
    return api.create(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/create_option`, {});
}

function createSceneFromStep(episodeId: string, sceneId: string, stepId: string) {
    return api.create(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/create_scene`, {});
}

function createLinkFromStep(episodeId: string, sceneId: string, stepId: string, data: any) {
    return api.create(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/steps/${stepId}/create_link`, data);
}

function deleteLink(episodeId: string, sceneId: string) {
    return api.delete(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/scenes/${sceneId}/delete_link`);
}


//background
function getEpisodeBackgrounds(episodeId: string, params: any) {
    return api.get(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/backgrounds`, params);
}

function createEpisodeBackground(episodeId: string, data: any) {
    return api.createWithFile(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/backgrounds`, data);
}

function deleteEpisodeBackground(episodeId: string, backgroundId: string) {
    return api.delete(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/backgrounds/${backgroundId}`);
}

function getEpisodeBackgroundDetail(episodeId: string, backgroundId: string) {
    return api.get(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/backgrounds/${backgroundId}`, {});
}

function updateEpisodeBackground(episodeId: string, backgroundId: string, model: any) {
    return api.updateWithFilePut(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/backgrounds/${backgroundId}`, model);
}

//sort Scenes
function sortScenes(episodeId: string, data: any) {
    return api.update(`${baseUrl}/${EPISODE_ENDPOINT}/${episodeId}/sort_scenes`, data);
}



export {
    getEpisodeById,
    getScenesByEpisodeId,
    updateScene,
    updateStep,
    deleteStep,
    updateOption,
    deleteOption,
    createStepFromStep,
    createBranchFromStep,
    createOptionFromStep,
    createSceneFromStep,
    getEpisodeBackgrounds,
    sortScenes,
    deleteScene,
    createEpisodeBackground,
    deleteEpisodeBackground,
    getEpisodeBackgroundDetail,
    updateEpisodeBackground,
    createLinkFromStep,
    deleteLink,
    createMultiStepFromStep
};

